var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppContext } from '../contexts/AppContextProvider';
import sanitizeHTML from '../utils/sanitizeHTML';
import { Button, Bubble } from '../components';
export var Menu = React.memo(function () {
    var appConfig = useAppContext().appConfig;
    return (_jsxs(_Fragment, { children: [_jsx(Bubble, { children: _jsx("div", { dangerouslySetInnerHTML: { __html: sanitizeHTML(appConfig.introTextHtml) } }) }), Object.keys(appConfig.forms).map(function (formName, index) { return (_jsx("div", { children: _jsx(Bubble, __assign({ className: "opt-button" }, { children: _jsx(Button, { buttonType: "navigate", formName: formName, title: appConfig.forms[formName].buttonText }) })) }, index)); })] }));
});
